import { render } from "./QuickpayPaymentOverviewSuccess.vue?vue&type=template&id=60d7a0f6&scoped=true"
import script from "./QuickpayPaymentOverviewSuccess.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentOverviewSuccess.vue?vue&type=script&lang=js"

import "./QuickpayPaymentOverviewSuccess.vue?vue&type=style&index=0&id=60d7a0f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d7a0f6"]])

export default __exports__